import axios from 'axios'
import { TYPES } from 'src/features/leads/constants'
import { DEFAULT_CLIENT_BUSINESS_TYPE } from 'src/features/clientes/constants'
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints'
import { composePhone } from 'src/features/common/phone/phoneUtils'

export async function createLead(leadData, assignedData, opportunityData, selectedExistingOpportunity) {
  const personType = leadData.personTypeNewValue || leadData.personType
  let body = {
    firstName: leadData.name,
    lastName: leadData.lastname,
    email: leadData.email,
    phone: composePhone(leadData.phoneCountryCode, leadData.phone),
    cuit: personType === TYPES.JURIDICA ? leadData.CUIT : null,
    businessName: personType === TYPES.JURIDICA ? leadData.businessName : null,
    clientId: leadData.id || null,
    personType,
    client_business_type: leadData.client_business_type || DEFAULT_CLIENT_BUSINESS_TYPE
  }

  if (selectedExistingOpportunity) {
    body.interest = selectedExistingOpportunity.interest
    body.origin = selectedExistingOpportunity.origin
    body.businessUnit =  selectedExistingOpportunity.business_unit
    body.campaign = selectedExistingOpportunity.campaign
    body.clientId = selectedExistingOpportunity.client_id
    body.observation = assignedData.observation
    body.opportunityId = selectedExistingOpportunity.id
    body.currentOpportunityState = selectedExistingOpportunity.state

    body.originNewLink = selectedExistingOpportunity.originNewLink

    const leadCarLotId = selectedExistingOpportunity.car_lot_id
    const leadBranchOfficeId = selectedExistingOpportunity.branch_office_id
    if (leadCarLotId || leadBranchOfficeId) {
      body.carlotId = leadCarLotId || null
      body.branchOfficeId = leadBranchOfficeId || null
    } else {
      body.carlotId = assignedData.carlotId
      body.branchOfficeId = assignedData.branchOfficeId
    }

    if (selectedExistingOpportunity.assigned_user_id) {
      body.assignedUserId = selectedExistingOpportunity.assigned_user_id
    } else {
      body.assignedUserId = assignedData.value || assignedData.user.value
    }

  } else {
    const {brand, model} = opportunityData
    body.interest =  brand ? model ? `${brand.label} ${model.label}` : brand.label : null
    body.origin = opportunityData.origin
    body.campaign = opportunityData.campaign
    body.businessUnit = opportunityData.businessUnit
    body.observation = opportunityData.observation
    body.carlotId = assignedData.carlotId
    body.branchOfficeId = assignedData.branchOfficeId
    body.assignedUserId = assignedData.value || assignedData.user.value
    body.responsibleUserId = assignedData.responsibleUser || null
  }
  try {
    const res = await axios.post(`${LEADS_ENDPOINT}`, body)
    return res
  } catch (error) {
      throw new Error(error)
  }
}
